module.exports = __webpack_public_path__ + "static/media/preferences.b135aa79.jpg";